import { render } from "./ColisPostaux.vue?vue&type=template&id=7fe8aea7&ts=true"
import script from "./ColisPostaux.vue?vue&type=script&lang=ts"
export * from "./ColisPostaux.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__